export const stores = ["COMMON", "DB", "STORIES", "CALENDAR", "VAL", "CATALOG", "REPOSITORY"];
